









































































import {
  SfHeading, SfButton, SfRadio, SfLoader,
} from '@storefront-ui/vue';

import { computed, defineComponent, ref } from '@nuxtjs/composition-api';
import type { PropType } from '@nuxtjs/composition-api';
import cartGetters from '~/modules/checkout/getters/cartGetters';
import useCart from '~/modules/checkout/composables/useCart';
import useShippingProvider from '~/modules/checkout/composables/useShippingProvider';
import getShippingMethodPrice from '~/helpers/checkout/getShippingMethodPrice';

import type { SelectedShippingMethod, AvailableShippingMethod } from '~/modules/GraphQL/types';

export default defineComponent({
  name: 'VsfShippingProvider',
  components: {
    SfHeading,
    SfButton,
    SfRadio,
    SfLoader,
  },
  props: {
    shippingMethods: {
      type: Array as PropType<AvailableShippingMethod[]>,
      default: () => [],
    },
  },
  setup() {
    const { cart } = useCart();
    const state = ref<SelectedShippingMethod | null>(null);

    const {
      save: saveShippingProvider,
      error: errorShippingProvider,
      loading: isLoading,
    } = useShippingProvider();

    const selectedShippingMethod = computed(() => state.value);
    const totals = computed(() => cartGetters.getTotals(cart.value));
    const isShippingMethodStepCompleted = computed(
      () => state.value?.method_code && !isLoading.value,
    );

    const selectShippingMethod = async (method: AvailableShippingMethod) => {
      const shippingData = {
        carrier_code: method.carrier_code,
        method_code: method.method_code,
      };

      state.value = await saveShippingProvider({
        shippingMethod: shippingData,
      });
    };

    return {
      errorShippingProvider,
      getShippingMethodPrice,
      isLoading,
      isShippingMethodStepCompleted,
      selectedShippingMethod,
      selectShippingMethod,
      state,
      totals,
    };
  },
});
